import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { BufferedSinkJsonWriter1xl4ankftitqq as BufferedSinkJsonWriter } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/BufferedSinkJsonWriter.mjs';
import { writeAny16i13331zbqlc as writeAny } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonWriters.mjs';
import { get_AnyAdapterx2g0krnqn0y9 as get_AnyAdapter } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { BufferedSourceJsonReader1eguw7qhrwt7p as BufferedSourceJsonReader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/BufferedSourceJsonReader.mjs';
import { Key_getInstance30q5r2nw695ls as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_receiveMessageMap__229hng($this, $completion) {
  while (true) {
    var tmp = $this.k69_1.i1b($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var map = $this.h6a(tmp);
    if (!(map == null)) {
      return map;
    }
  }
}
function *_generator_run__cb7u2f($this, $completion) {
  try {
    while (true) {
      var tmp = $this.m69($completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      $this.y69(tmp);
    }
  } catch ($p) {
    if ($p instanceof CancellationException()) {
      var e = $p;
      throw e;
    } else {
      if ($p instanceof Exception()) {
        var e_0 = $p;
        $this.l69_1.n6c(e_0);
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
var WsProtocolClass;
function WsProtocol() {
  if (WsProtocolClass === VOID) {
    class $ {
      constructor(webSocketConnection, listener) {
        this.k69_1 = webSocketConnection;
        this.l69_1 = listener;
      }
      f6a(_this__u8e3s4) {
        // Inline function 'com.apollographql.apollo.api.json.buildJsonByteString' call
        var buffer = new (Buffer())();
        var $this$buildJsonByteString = new (BufferedSinkJsonWriter())(buffer, null);
        writeAny($this$buildJsonByteString, _this__u8e3s4);
        return buffer.k3y();
      }
      g6a(_this__u8e3s4) {
        // Inline function 'com.apollographql.apollo.api.json.buildJsonString' call
        var buffer = new (Buffer())();
        var $this$buildJsonString = new (BufferedSinkJsonWriter())(buffer, null);
        writeAny($this$buildJsonString, _this__u8e3s4);
        return buffer.o3y();
      }
      h6a(_this__u8e3s4) {
        var tmp;
        try {
          var tmp_0 = get_AnyAdapter().z3z(new (BufferedSourceJsonReader())((new (Buffer())()).y3y(_this__u8e3s4)), Key_getInstance().v45_1);
          tmp = isInterface(tmp_0, KtMap()) ? tmp_0 : null;
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Exception()) {
            var e = $p;
            tmp_1 = null;
          } else {
            throw $p;
          }
          tmp = tmp_1;
        }
        return tmp;
      }
      i6a(messageMap) {
        this.k69_1.r6c(this.f6a(messageMap));
      }
      j6a(messageMap) {
        this.k69_1.s6c(this.g6a(messageMap));
      }
      s69(messageMap, frameType) {
        switch (frameType.b2_1) {
          case 0:
            this.j6a(messageMap);
            break;
          case 1:
            this.i6a(messageMap);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
      }
      m69($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_receiveMessageMap__229hng.bind(VOID, this), $completion);
      }
      k6a($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_run__cb7u2f.bind(VOID, this), $completion);
      }
      q6() {
        this.k69_1.q6();
      }
    }
    initMetadataForClass($, 'WsProtocol', VOID, VOID, VOID, [0]);
    WsProtocolClass = $;
  }
  return WsProtocolClass;
}
var WsFrameType_Text_instance;
var WsFrameType_Binary_instance;
var WsFrameType_entriesInitialized;
function WsFrameType_initEntries() {
  if (WsFrameType_entriesInitialized)
    return Unit_instance;
  WsFrameType_entriesInitialized = true;
  WsFrameType_Text_instance = new (WsFrameType())('Text', 0);
  WsFrameType_Binary_instance = new (WsFrameType())('Binary', 1);
}
var WsFrameTypeClass;
function WsFrameType() {
  if (WsFrameTypeClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'WsFrameType');
    WsFrameTypeClass = $;
  }
  return WsFrameTypeClass;
}
function WsFrameType_Text_getInstance() {
  WsFrameType_initEntries();
  return WsFrameType_Text_instance;
}
//region block: exports
export {
  WsProtocol as WsProtocol2u70gp1eq7nu9,
  WsFrameType_Text_getInstance as WsFrameType_Text_getInstancep47mhyh18o1i,
};
//endregion

//# sourceMappingURL=WsProtocol.mjs.map
